module.exports = __webpack_public_path__ + "media/images/weather/249_day-f898cd210e5dab694665890f055784e7.png";